module.exports = __webpack_public_path__ + "media/images/countrysquared/bd-becc86f7e5b81a4599754b222ea63efd.svg";